module.exports = __webpack_public_path__ + "static/img/c2.5a7d896e.svg";